import React from "react";
import SRCLogo from "../../Photos/src-logo.svg"
import './SRC.scss'
import HowInvolved from "../../SVGElements/HOW CAN I GET INVOLVED_.svg"
import HowFitIn from "../../SVGElements/HOW DOES IT FIT IN THE CS15 CURRICULUM_.svg"
import WhatIsIt from "../../SVGElements/WHAT IS SRC_.svg"
import { TableSection } from "../TableSection/TableSection";
import { RowOptions } from "../TableSection/TableSection";
import { SectionProps } from "../../App";

interface SRCProps {}

export class SRC extends React.Component<SectionProps> {
    render(){
        return(
            <section className={`src ${this.props.static ? 'static' : ''}`}>
                <div className = "content-container">
                    <div className ="header-container">
                    <img  className="src-logo logo" src={SRCLogo} alt="src text" />
                    </div>

                    <div className="src-container">
                        <div className="src-topics>"></div>
                        <div className ="src-item">
                            <div className="center-span"><center><img className="subsection-title-svg" src={WhatIsIt}/></center></div>
                            <p style={{"margin": "0px", "marginBottom": "1.5rem"}}>As awareness of technology's consequences increases, attention turns to how computer scientists are trained. In response, the CS department created the "Socially Responsible Computing" initiative in 2019 to integrate ethics and social impact topics broadly across its curriculum. At Brown, SRC is embedded into most major CS courses. Our goals in CS15 are to give a broad overview of today's technological landscape so that you are familiar with these concepts when you are eventually faced with ethical design decisions further down your CS journey.</p>
                            <div className="center-span"><center><div style={{"fontSize": "xx-large", "fontWeight": 700}}>How Does it Fit in With the CS15 Curriculum?</div></center></div>
                            <ul>
                                <li style={{"fontSize": "xx-large"}}>Mini-Assignments</li>
                                <li style={{"fontSize": "xx-large"}}>Lab activities about lecture content</li>
                                <li style={{"fontSize": "xx-large"}}>Two extra credit discussion sections with details TBA</li>
                            </ul>
                        </div>
                        <div className = "src-item">
                        <div className="center-span"><center><img className="subsection-title-svg" src={HowInvolved}/></center></div>
                            <br></br>
                            <h4 style={{"fontSize": "x-large"}}>Groups @ Brown:</h4>
                            <ul style={{"margin": "3px"}}>
                                <li>SRC Reading group: ARG@Brown</li>
                                <li>AIRES (AI Robotics Ethics Society@Brown)</li>
                                <li>Human Centered Robotics Initiative</li>
                                <li>Design for America @ Brown</li>
                            </ul>
                            <h4 style={{"fontSize": "x-large"}}>Alum-founded groups & others:</h4>
                            <ul style={{"margin": "3px"}}>
                                <li>Better World by Design</li>
                                <li>Impact Labs</li>
                                <li>Coding it Forward</li>
                                <li>TechCongress</li>
                            </ul>
                            <h4 style={{"fontSize": "x-large"}}>Classes @ Brown:</h4>
                            <ul style={{"margin": "3px"}}>
                                <li>CSCI1870: Cybersecurity Ethics</li>
                                <li>CSCI1951I: CS for Social Change</li>
                                <li>DATA0080: Data, Ethics and Privacy</li>
                                <li>MCM0230: Digital Media</li>
                                <li>PHIL401: Ethics of Digital Technology</li>
                                <li>STS 1700T: Race, Gender, and Technology in Everyday Life</li>
                                <li>Classes under the 'Science, Technology, and Society' (STS) department</li>
                                <li>...and more!</li>
                            </ul>

                        </div>
                    </div>
                    <br></br>
                        <h3>Topics in Socially Responsible Computing</h3>
                        <div id="flip-card-container" className = "cards-container src-cards">
                            <div className = "flip-card">
                                <div className = "flip-card-inner">
                                    <div className="flip-card-front">
                                        <h3>Big Tech</h3>
                                    </div>
                                    <div className="flip-card-back">
                                        <h3>Big Tech</h3>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 2</p>
                                            </div>

                                        </ul>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 7</p>
                                            </div>
                                        </ul>
                                    </div>

                                </div>  
                            </div>

                            <div className = "flip-card">
                                <div className = "flip-card-inner">
                                    <div className="flip-card-front">
                                        <h3>Artificial Intelligence</h3>
                                    </div>
                                    <div className="flip-card-back">
                                        <h3>AI</h3>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 3</p>
                                            </div>
                                        </ul>
                                        <ul>

                                            <div className="box">
                                                <p>Lecture 4</p>
                                            </div>

                                            </ul>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 5</p>
                                            </div>

                                            </ul>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 6</p>
                                            </div>
                                        </ul>
                                    </div>

                                </div>  
                            </div>

                            <div className = "flip-card">
                                <div className = "flip-card-inner">
                                    <div className="flip-card-front">
                                        <h3>Blockchain and Crypto</h3>
                                    </div>
                                    <div className="flip-card-back">
                                        <h3>Blockchain and Crypto</h3>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 8</p>
                                            </div>
                                        </ul>
                                    </div>

                                </div>  
                            </div>

                            <div className = "flip-card">
                                <div className = "flip-card-inner">
                                    <div className="flip-card-front">
                                        <h3>Environ&shy;mental Costs of Computing</h3>
                                            </div>
                                            <div className="flip-card-back">
                                                <h3>Environ&shy;mental Costs of Computing</h3>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 9</p>
                                            </div>
                                            </ul>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 10</p>
                                            </div>
                                        </ul>
                                    </div>

                                </div>  
                            </div>


                            <div className = "flip-card">
                                <div className = "flip-card-inner">
                                    <div className="flip-card-front">
                                        <h3>Privacy and Govern&shy;mental Surveil&shy;lance</h3>
                                            </div>
                                            <div className="flip-card-back">
                                                <h3>Privacy and Govern&shy;mental Surveil&shy;lance</h3>
                                                <ul>
                                            <div className="box">
                                                <p>Lecture 11</p>
                                            </div>
                                            </ul>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 12</p>
                                            </div>
                                        </ul>
                                    </div>

                                </div>  
                            </div>

                            <div className = "flip-card">
                                <div className = "flip-card-inner">
                                    <div className="flip-card-front">
                                        <h3>Accessible Design</h3>
                                    </div>
                                    <div className="flip-card-back">
                                        <h3>Accessible Design</h3>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 13</p>
                                            </div>
                                        </ul>
                                    </div>

                                </div>  
                            </div>

                            <div className = "flip-card">
                                <div className = "flip-card-inner">
                                    <div className="flip-card-front">
                                        <h3>Manipulative Design</h3>
                                    </div>
                                    <div className="flip-card-back">
                                        <h3>Manipulative Design</h3>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 14</p>
                                            </div>
                                        </ul>
                                    </div>

                                </div>  
                            </div>

                            <div className = "flip-card">
                                <div className = "flip-card-inner">
                                    <div className="flip-card-front">
                                        <h3>Social Media</h3>
                                    </div>
                                    <div className="flip-card-back">
                                        <h3>Social Media</h3>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 15</p>
                                            </div>
                                            </ul>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 16</p>
                                            </div>
                                            </ul>
                                    </div>

                                </div>  
                            </div>

                            <div className = "flip-card">
                                <div className = "flip-card-inner">
                                    <div className="flip-card-front">
                                        <h3>Good Tech</h3>
                                    </div>
                                    <div className="flip-card-back">
                                        <h3>Good Tech</h3>
                                        <ul>
                                            <div className="box">
                                                <p>Lecture 17</p>
                                            </div>
                                        </ul>
                                    </div>

                                </div>  
                            </div>
                        </div>
                    </div>

                
                <div id="bigtech1" className="overlay">
                    <div className="popup">
                        <h3>Big Tech Overview</h3>
                        <a className = "close" href="#src-topics"></a>
                    </div>
                </div>
                

                
            </section>
        );
    }
}

interface SRCContentProps {}

export class SRCContent extends React.Component<SRCContentProps> {
    myHeader: string[] = ["Date", "Lecture"];
    myRows: RowOptions[] = [
    {
        cellNames: ["9/4", "Intro to SRC"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["9/9", "Big Tech"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["9/11", "What is AI"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["9/16", "Intro to NNs"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["9/18", "AI Alignment"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["9/23", "AI Safety and Socio-Political Issues"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["9/25", "Future of Work and Education"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["9/27", "Antitrust"],
        cellNametoLinks: new Map<string, string>([]),
    },  
    {
        cellNames: ["10/2", "Blockchain and Crypto"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["10/7", "Energy Usage, Implications, and Solutions"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["10/9", "Energy Solutions and Techno Solutionism"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["10/14", "Privacy: a brief history"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["10/16", "Privacy: cases and protective laws"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["10/21", "Accessible Design"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["10/23", "Manipulative and Coercive, Addictive Designs"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["10/28", "Social Media I: Misinformation"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["10/30", "Social Media II: Negative Effects"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["11/4", "Good Tech"],
        cellNametoLinks: new Map<string, string>([]),
    },
    {
        cellNames: ["11/6", "SRC After CS15"],
        cellNametoLinks: new Map<string, string>([]),
    },
];

    render() {
        return (
            <section id="lectures" className="anchor lectures">
                <div className="content-container">
                    <h2>Lecture Schedule</h2>
                    <TableSection
                        header={this.myHeader}
                        rows={this.myRows}
                    />
                </div>
            </section>
        );
    }
}